import { render, staticRenderFns } from "./birthdayWishes.vue?vue&type=template&id=1cc0f3c0&scoped=true&"
import script from "./birthdayWishes.vue?vue&type=script&lang=js&"
export * from "./birthdayWishes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc0f3c0",
  null
  
)

export default component.exports